<template>
  <div class="app-container">
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column width="200" prop="fileName" :label="$t('billingPage.FileName')" align="center"></el-table-column>
      <el-table-column width="120" prop="invoiceDate" :label="$t('billingPage.InvoiceDate')" align="center"></el-table-column>
      <el-table-column width="120" prop="operatedDate" :label="$t('billingPage.OperatedDate')" align="center"></el-table-column>
      <el-table-column width="80" prop="createdBy" :label="$t('billingPage.Operator')" align="center"></el-table-column>
      <el-table-column prop="chargedOrders" :label="$t('billingPage.ChargedOrders')" align="center"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import { billApi } from '@/api';
export default {
  data() {
    return {
      tableData: [],
    };
  },
  mounted() {
    this.getPageDataList();
  },
  methods: {
    // 获取页面数据
    getPageDataList() {
      billApi.dbSavedFileHistoryList().then(res => {
        this.tableData = res.data.content;
      });
    },
  },
};
</script>
